/**
 * appConstant
 *
 * @Author  Yee
 * @DATE    create on 2019/9/6
 * @DESC    全局魔法变量
 */
export const APP_VAR = {
  APP_ENV_INFO: 'APP_ENV_INFO'
}
